import { env } from "build/env";
export const pushToMiScusi = (historyPush, url) => {
  if (!(historyPush && historyPush.bind)) {
    throw new Error("the first argument should be the actual history.push");
  }
  window.location.href = "".concat(env.URL_MISCUSI).concat(url || "/");
};
export const homepageUrl = "/homepage";
export const pushToWebsiteHomepage = () => {
  const {
    URL_MISCUSI
  } = env;
  const websiteHomepageUrl = "".concat(window.location.protocol, "//").concat(URL_MISCUSI);
  window.location.assign(websiteHomepageUrl);
};